const initialState = { movies: [] };

function movieReducer(state = initialState, action) {
  console.log(state, "ini state bos");
  switch (action.type) {
    case "SET_MOVIES":
      return {
        ...state,
        movies: action.payload.movies,
      };
    default:
      return state;
  }
}

export default movieReducer;
